import { render } from "./StoryView.vue?vue&type=template&id=2a624d90"
import script from "./StoryView.vue?vue&type=script&lang=js"
export * from "./StoryView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__